module.exports = __webpack_public_path__ + "img/log-out.95bd7609.svg";